<template>
  <v-container>
    <v-flex>
      <v-card :id="id" class="pa-6" v-on="generateClickBehaviour(routeTo)">
        <v-card-title primary-title class="justify-center pb-8">
          <h2 class="headline primary--text text--accent-2 text-no-wrap">
            {{ header }}
          </h2>
        </v-card-title>
        <v-divider v-if="showDivider" dotted class="ma-0"></v-divider>
        <v-card-subtitle v-if="subHeader !== ''" class="text-center">
          <h3
            class="subheading primary--text text--accent-2 font-weight-thin pt-8"
          >
            {{ subHeader }}
          </h3>
        </v-card-subtitle>
        <v-card-text class="text-center">
          <v-row>
            <v-col :lg="colLg">
              <p v-html="content"></p>
            </v-col>
            <v-col v-if="image !== ''" :lg="colLg">
              <v-img :src="image" contain max-height="200"></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    routeTo: {
      type: String,
      default: ''
    },
    header: {
      type: String,
      default: ''
    },
    subHeader: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    },
    showDivider: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      colLg: this.image !== '' ? 6 : 12
    }
  },
  methods: {
    clickHandler() {
      this.$router.push({ name: this.routeTo })
    },
    generateClickBehaviour(routeTo) {
      return routeTo !== '' ? { click: this.clickHandler } : {}
    }
  }
}
</script>
